import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  stock_opname_details: [],
};

const getters = {
  allStockOpnameDetails: (state) => state.stock_opname_details,
};

const actions = {
  async fetchStockOpnameDetails({ commit }, params = {}) {
    try {
      commit("resetStockOpnameDetails");
      const response = await axios.get("/stock-opname-detail", { params: prm(params) });
      commit("setStockOpnameDetails", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch stock_opname_details:", error);
    }
  },
  async createStockOpnameDetail({ commit }, stock_opname_detail) {
    try {
      const response = await axios.post("/stock-opname-detail", stock_opname_detail);
      commit("addStockOpnameDetail", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create stock_opname_detail:", error);
      throw error;
    }
  },
  async fetchStockOpnameDetailById(_, id) {
    try {
      const response = await axios.get(`/stock-opname-detail/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch stock_opname_detail:", error);
      throw error;
    }
  },
  async updateStockOpnameDetail({ commit }, stock_opname_detail) {
    try {
      const response = await axios.put(`/stock-opname-detail/${stock_opname_detail.id}`, stock_opname_detail);
      commit("updateStockOpnameDetail", response.data);
    } catch (error) {
      console.error("Failed to update stock_opname_detail:", error);
      throw error;
    }
  },
  async deleteStockOpnameDetailById({ commit }, id) {
    try {
      const response = await axios.delete(`/stock-opname-detail/${id}`);
      commit("removeStockOpnameDetail", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete stock_opname_detail:", error);
      throw error;
    }
  },
};

const mutations = {
  setStockOpnameDetails(state, stock_opname_details) {
    state.stock_opname_details = stock_opname_details.data; // Ensure this matches your API's response structure
  },
  addStockOpnameDetail(state, stock_opname_detail) {
    state.stock_opname_details.push(stock_opname_detail);
  },
  updateStockOpnameDetail(state, updatedStockOpnameDetail) {
    const index = state.stock_opname_details.findIndex(
      (stock_opname_detail) => stock_opname_detail.id === updatedStockOpnameDetail.id
    );
    if (index !== -1) {
      state.stock_opname_details.splice(index, 1, updatedStockOpnameDetail);
    }
  },
  removeStockOpnameDetail(state, id) {
    state.stock_opname_details = state.stock_opname_details.filter(
      (stock_opname_detail) => stock_opname_detail.id !== id
    );
  },
  resetStockOpnameDetails(state) {
    state.stock_opname_details = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
